/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Quote Right",
  size: 20
}

const SvgQuoteRight = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M17.27 7.79c0 1.66-.3 2.64-1.28 4.23-1.01 1.62-2.99 3.21-4.43 3.95l-.46-.89c1.24-.88 2.04-1.57 2.92-3.26.25-.48.39-.9.47-1.28-.19.04-.4.06-.61.06-1.82 0-3.29-1.48-3.29-3.3 0-1.82 1.47-3.3 3.29-3.3 1.51 0 2.79 1.02 3.17 2.42.14.4.22.85.22 1.37zM8.68 7.79c0 1.66-.3 2.64-1.28 4.23-1.01 1.62-2.99 3.21-4.43 3.95l-.46-.89c1.24-.88 2.04-1.57 2.92-3.26.25-.48.39-.9.47-1.28-.19.04-.4.06-.61.06C3.47 10.6 2 9.12 2 7.3 2 5.48 3.47 4 5.29 4 6.8 4 8.08 5.02 8.46 6.42c.14.4.22.85.22 1.37z" />
  </Svg>
)

SvgQuoteRight.defaultProps = defaultProps
export default SvgQuoteRight
